import {
  PayloadAction,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit';

import { LoadingStates } from '@tdp/common/constants';
import { createEntityFormAdapter } from '@tdp/common/form';

import { BotFrameworkBot, BotFrameworkBotSchema, EmptyBotFrameworkBot } from './models';

// need to use the full type declaration because 'id' isn't defined on bot
const botEntityAdapter = createEntityAdapter<BotFrameworkBot, string>({
  selectId: (bot) => bot.botId,
});

const botFormEntityAdapter = createEntityFormAdapter(botEntityAdapter);

export const botSlice = createSlice({
  name: 'bots',
  initialState: botFormEntityAdapter.getInitialState({
    loading: false,
    botListApiStatus: LoadingStates.NOT_STARTED,
    botDetailsApiStatus: LoadingStates.NOT_STARTED,
  }),
  reducers: {
    botDetailsLoading: (state) => {
      state.botDetailsApiStatus = LoadingStates.LOADING;
    },
    botDetailsLoadingFailed: (state) => {
      state.botDetailsApiStatus = LoadingStates.ERROR;
    },
    botDetailsLoadingSuccess: (state) => {
      state.botDetailsApiStatus = LoadingStates.SUCCESS;
    },
    loadBotDetails(state, action: PayloadAction<BotFrameworkBot>) {
      botEntityAdapter.upsertOne(state, action.payload);
      state.loading = false;
    },
    botsLoading: (state) => {
      state.loading = true;
      state.botListApiStatus = LoadingStates.LOADING;
    },
    botListLoadingFailed: (state) => {
      state.botListApiStatus = LoadingStates.ERROR;
    },
    botsLoaded: (state, action: PayloadAction<BotFrameworkBot[]>) => {
      // we assume the loading of bots means we're no longer loading the bots.
      state.loading = false;
      botEntityAdapter.upsertMany(state, action.payload);
      state.botListApiStatus = LoadingStates.SUCCESS;
    },
    newBotCreated(state, action: PayloadAction<BotFrameworkBot>) {
      botEntityAdapter.addOne(state, action.payload);
    },
    botUpdated(state, action: PayloadAction<BotFrameworkBot>) {
      botEntityAdapter.upsertOne(state, action.payload);
    },
    ...botFormEntityAdapter.getReducers(),
  },
  selectors: {
    isLoading: (s) => s.loading,
    botListApiStatus: (s) => s.botListApiStatus,
    getBotDetailsApiStatus: (s) => s.botDetailsApiStatus,
    ...botEntityAdapter.getSelectors(), //generally not the best option, but it works for now.
    ...botFormEntityAdapter.getSelectors(EmptyBotFrameworkBot, BotFrameworkBotSchema),
  },
});
